// SPDX-License-Identifier: LicenseRef-Proprietary

/**
 * Filter out null/undefined/empty authors and get valid ones
 * Single source of truth for author validation
 * 
 * @param authors - Array of author strings (may contain null/undefined/empty values)
 * @returns Array of valid, non-empty author strings
 */
export function getValidAuthors(authors: (string | null | undefined)[] | undefined): string[] {
  if (!authors) return [];
  return authors.filter((author): author is string => 
    author !== null && author !== undefined && typeof author === 'string' && author.trim().length > 0
  );
}

